import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const TermsModal = ({ content, onSubmit, onClose }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="link-1-wrap">
        <div className="link-wrap">
          <div className="header">
            <div className="title">
              <div className="middle">{t('terms_title')}</div>
            </div>
          </div>
          <div className="content">
            <div
              className="text"
              dangerouslySetInnerHTML={{
                __html: `${t('terms_contents')}`,
              }}
            />
          </div>
          <div className="footer" onClick={() => onClose()}>
            <div className="link-1-close">
              <div className="middle">
                <div className="close">{t('close')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsModal;
